export const macroDetailData = {
  gdp: {
    current: 115,
    currency: 'USD',
    growth: 7.6,
    forecast2025: 6.5,
    forecast2026: 6.0,
    perCapita: 3100,
    perCapitaPPP: 10800,
    composition: [
      { sector: 'Services', share: 47.2, growth: 7.1 },
      { sector: 'Industry', share: 28.4, growth: 5.8 },
      { sector: 'Agriculture', share: 24.4, growth: 3.2 },
    ],
    history: [
      { year: '2019', value: 57.9, growth: 5.8 },
      { year: '2020', value: 60.0, growth: 1.9 },
      { year: '2021', value: 69.2, growth: 7.4 },
      { year: '2022', value: 80.4, growth: 5.7 },
      { year: '2023', value: 90.4, growth: 6.3 },
      { year: '2024', value: 114.97, growth: 6.5 },
      { year: '2025', value: 122.6, growth: 7.6 },
    ],
  },

  inflation: {
    cpiCurrent: 7.5,
    cpiTarget: 5.0,
    cpiPrev: 9.0,
    ppiCurrent: 10.2,
    foodInflation: 6.8,
    coreInflation: 6.3,
    history: [
      { month: 'JUN', cpi: 9.2, target: 5.0 },
      { month: 'JUL', cpi: 8.8, target: 5.0 },
      { month: 'AUG', cpi: 8.5, target: 5.0 },
      { month: 'SEP', cpi: 8.2, target: 5.0 },
      { month: 'OCT', cpi: 7.9, target: 5.0 },
      { month: 'NOV', cpi: 7.5, target: 5.0 },
    ],
    forecast: [
      { year: '2025', value: 8.0 },
      { year: '2026', value: 6.5 },
      { year: '2027', value: 5.5 },
      { year: '2028', value: 5.0 },
    ],
  },

  fiscal: {
    budgetBalance: -3.0,
    budgetBalancePrev: -4.2,
    publicDebt: 33,
    publicDebtPrev: 35,
    externalDebt: 42,
    debtToGDP: 33,
    revenue: 28.5,
    expenditure: 31.5,
    breakdown: [
      { item: 'Social Spending', pctGDP: 12.5 },
      { item: 'Infrastructure', pctGDP: 6.2 },
      { item: 'Education', pctGDP: 5.8 },
      { item: 'Healthcare', pctGDP: 3.4 },
      { item: 'Defense', pctGDP: 2.1 },
      { item: 'Other', pctGDP: 1.5 },
    ],
  },

  trade: {
    exports: 24.5,
    imports: 32.8,
    tradeBalance: -8.3,
    currentAccount: -5.0,
    currentAccountPrev: -7.2,
    topExports: [
      { product: 'Gold', share: 32.5, value: 7.96 },
      { product: 'Natural Gas', share: 12.8, value: 3.14 },
      { product: 'Cotton', share: 8.4, value: 2.06 },
      { product: 'Textiles', share: 7.2, value: 1.76 },
      { product: 'Food Products', share: 5.1, value: 1.25 },
    ],
    topPartners: [
      { country: 'CHN', exports: 18.5, imports: 24.2 },
      { country: 'RUS', exports: 14.2, imports: 18.6 },
      { country: 'KAZ', exports: 8.4, imports: 6.8 },
      { country: 'TUR', exports: 7.8, imports: 8.2 },
      { country: 'KOR', exports: 5.2, imports: 4.1 },
    ],
  },

  fx: {
    uzsUsd: 12098,
    uzsUsdPrev: 12750,
    uzsChange: 5.1,
    reserves: 49.7,
    reservesPrev: 41.0,
    reservesMonths: 11,
    goldReserves: 38.3,
    interventions: 'MINIMAL',
    regime: 'MANAGED FLOAT',
    history: [
      { month: 'JUL', rate: 12680 },
      { month: 'AUG', rate: 12720 },
      { month: 'SEP', rate: 12580 },
      { month: 'OCT', rate: 12350 },
      { month: 'NOV', rate: 12180 },
      { month: 'DEC', rate: 12098 },
    ],
  },

  forecasts: [
    { indicator: 'GDP Growth', unit: '%', '2024': 6.5, '2025E': 6.2, '2026E': 6.0, '2027E': 5.8, '2028E': 5.5, source: 'IMF' },
    { indicator: 'Inflation', unit: '%', '2024': 10.4, '2025E': 8.0, '2026E': 6.5, '2027E': 5.5, '2028E': 5.0, source: 'CBU' },
    { indicator: 'Current Account', unit: '%GDP', '2024': -5.0, '2025E': -4.5, '2026E': -4.0, '2027E': -3.5, '2028E': -3.0, source: 'IMF' },
    { indicator: 'Public Debt', unit: '%GDP', '2024': 33, '2025E': 32, '2026E': 31, '2027E': 30, '2028E': 29, source: 'WB' },
    { indicator: 'FX Reserves', unit: 'USD B', '2024': 49.7, '2025E': 52.0, '2026E': 55.0, '2027E': 58.0, '2028E': 62.0, source: 'CBU' },
    { indicator: 'Population', unit: 'M', '2024': 37.1, '2025E': 37.7, '2026E': 38.3, '2027E': 38.9, '2028E': 39.5, source: 'UN' },
  ],

  // Central Asia & Silk Road regional comparison
  comparison: {
    gdpGrowth: [
      { year: '2020', uzb: 1.9, kaz: -2.5, geo: -6.8, emerging: -1.8 },
      { year: '2021', uzb: 7.4, kaz: 4.3, geo: 10.5, emerging: 6.9 },
      { year: '2022', uzb: 5.7, kaz: 3.2, geo: 10.1, emerging: 4.0 },
      { year: '2023', uzb: 6.3, kaz: 5.1, geo: 7.5, emerging: 4.1 },
      { year: '2024', uzb: 6.5, kaz: 5.2, geo: 7.0, emerging: 4.2 },
      { year: '2025E', uzb: 6.2, kaz: 5.5, geo: 5.5, emerging: 4.3 },
    ],
  },
};
